import FaIcon, { faChevronDown, faChevronLeft, faChevronRight, faChevronUp } from '@/components/icon/FaIcon/FaIcon';
import clsx from 'clsx';
import styles from './RoundArrowIcon.module.scss';

function RoundArrowIcon({
  direction = 'right',
  color,
  size = 'default',
  sizePc,
  bgColor,
  borderColor,
  isBold = false,
}: {
  direction?: 'right' | 'left' | 'up' | 'down';
  color: string;
  size?: 'default' | 'small' | 'large' | 'xLarge';
  sizePc?: 'default' | 'small' | 'medium' | 'large' | 'xLarge';
  bgColor?: string;
  borderColor?: string;
  isBold?: boolean;
}) {
  const arrowIcon = () => {
    if (direction === 'up') return <FaIcon icon={faChevronUp} />;
    if (direction === 'down') return <FaIcon icon={faChevronDown} />;
    if (direction === 'right') return <FaIcon icon={faChevronRight} />;
    if (direction === 'left') return <FaIcon icon={faChevronLeft} />;
  };

  const getBorderColor = () => {
    if (!borderColor) return `var(--color-${color})`;
    if (borderColor === 'transparent') return 'transparent';
    return `var(--color-${borderColor})`;
  };

  const getPcContainerClassName = () => {
    if (sizePc) return styles[`${sizePc}PcContainer`];
    return styles[`${size}Container`];
  };

  return (
    <div className={styles.componentStyle}>
      <div
        className={clsx(
          styles[`${size}Container`],
          getPcContainerClassName(),
          styles.commonContainer,
          isBold ? styles.boldCircle : styles.defaultCircle,
        )}
        style={{
          color: `var(--color-${color})`,
          backgroundColor: bgColor ? `var(--color-${bgColor})` : undefined,
          borderColor: getBorderColor(),
        }}
      >
        {arrowIcon()}
      </div>
    </div>
  );
}

export default RoundArrowIcon;
